import React, { createContext } from 'react';
import { CategoryType, PulseCheckWorkflow } from '../../api/useWorkflowQuery';

interface Context {
  data: PulseCheckWorkflow;
  categories: CategoryType[];
  setCategories: React.Dispatch<React.SetStateAction<CategoryType[]>>;
  stepIndex: number;
  setStepIndex: (index: number) => void;
  showCategoryNumbers: boolean;
  setShowCategoryNumbers: (showCategoryNumbers: boolean) => void;
}

export const WorkflowContext = createContext<Context | undefined>(undefined);

interface Props {
  value: Context;
  children: React.ReactNode;
}

export const WorkflowProvider = ({ children, value }: Props) => (
  <WorkflowContext.Provider value={value}>{children}</WorkflowContext.Provider>
);
